import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { DataTable } from '@/shared/components/data-table';
import type { QmsTicket } from '../types/qms.types';
import type {
  QmsTicketColumnDef,
  QmsTicketRenderContext,
} from '../hooks/useQmsTicketListTable';

interface QmsTicketListViewProps {
  sortedTickets: QmsTicket[];
  visibleColumns: QmsTicketColumnDef[];
  columnFilters: Record<string, string>;
  ctx: QmsTicketRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading?: boolean;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onSelectTicket: (ticket: QmsTicket) => void;
  onCreateTicket?: () => void;
}

export function QmsTicketListView({
  sortedTickets,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  onSort,
  onSetColumnFilter,
  onSelectTicket,
  onCreateTicket,
}: QmsTicketListViewProps) {
  return (
    <div className="space-y-2">
      <DataTable<QmsTicket, QmsTicketRenderContext>
        items={sortedTickets}
        columns={visibleColumns}
        ctx={ctx}
        columnFilters={columnFilters}
        sortKey={sortKey}
        sortDirection={sortDirection}
        isLoading={isLoading}
        onSort={onSort}
        onSetColumnFilter={onSetColumnFilter}
        onRowClick={onSelectTicket}
        emptyState={
          <>
            No tickets found.{' '}
            {onCreateTicket && (
              <Button variant="link" size="sm" onClick={onCreateTicket}>
                <Plus className="h-4 w-4 mr-1" />
                Add Ticket
              </Button>
            )}
          </>
        }
      />
    </div>
  );
}
